// extracted by mini-css-extract-plugin
module.exports = {"selectLanguageBlockText":"SelectLanguage_selectLanguageBlockText__1x5wB","ja":"SelectLanguage_ja__2tyHn","en":"SelectLanguage_en__bOhzj","spin":"SelectLanguage_spin__g1nSe"};